'use strict';

const BCL_RUN_ARCHIVE_PATTERN =
  /\.(?:bcl|cbcl)(?:\.tar(?:\.(?:gz|zst))?|\.tgz)$/i;

function isBclRunArchive(fileName) {
  return (
    typeof fileName === 'string' &&
    BCL_RUN_ARCHIVE_PATTERN.test(fileName.trim())
  );
}

module.exports = { isBclRunArchive };
